import React from 'react';
import classnames from 'classnames';
import { gikClassPrefix } from '@gik/core/constants';
import { createContainer } from 'unstated-next';

export interface RadioGroupProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  name?: string;
  value?: string;
  defaultValue?: string;
  inline?: boolean;
  onChange?: (value: string) => void;
}

// block name for this component
const blockName = `${gikClassPrefix}-radio-group`;

export interface RadioGroupState {
  name?: string;
  value?: string;
  setValue?: (value: string) => void;
  setName?: (value: string) => void;
  onChange?: (value: string) => void;
}

function useRadioGroupContext(state: RadioGroupState): RadioGroupState {
  const [value, setValue] = React.useState(state.value);
  const [name, setName] = React.useState(state.name);
  return { value, setValue, name, setName, onChange: state.onChange };
}

export const RadioGroupContext = createContainer(useRadioGroupContext);

export default function RadioGroup({
  className,
  children,
  name,
  value,
  inline,
  defaultValue,
  onChange,
  ...otherProps
}: RadioGroupProps): React.ReactElement {
  const _value = value || defaultValue;

  const blockClasses = classnames([blockName, { [`${blockName}--inline`]: inline }, className || '']);

  return (
    <RadioGroupContext.Provider
      initialState={{
        name,
        value: _value,
        onChange,
      }}
    >
      <div {...otherProps} className={blockClasses}>
        {children}
      </div>
    </RadioGroupContext.Provider>
  );
}
